import React from 'react'
import { Link } from 'react-router-dom'

const ServiceView = () => {
    return (
        <div className="service-area-1 space overflow-hidden">
            <div className="container">
                {/* Cabeçalho da Seção */}
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="title-area text-center mb-50">
                            <h2 className="sec-title style2">
                                A parceria certa para garantir qualidade, aderência cultural e retenção.
                            </h2>
                            <p className="sec-text mt-3">
                                Unimos processos modernos orientados por performance a uma visão corporativa premium e humanizada.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Quadrante de Cards (4 Diferenciais) */}
                <div className="row gx-30 gy-30 justify-content-center">
                    <div className="col-md-6">
                        <div className="service-card">
                            <div className="service-card_img">
                                <img src="assets/img/servicos/1/1.png" alt="Atendimento Consultivo Rocvel" />
                            </div>
                            <div className="service-card_content">
                                <h4 className="service-card_title">
                                    <Link to="/recrutamento-e-selecao">Atendimento Consultivo</Link>
                                </h4>
                                <p className="service-card_text">
                                    Oferecemos um suporte totalmente personalizado de ponta a ponta. Nossa equipe estuda a fundo o ecossistema e as necessidades reais da sua empresa antes de desenhar a solução ideal.
                                </p>
                                <Link to="/recrutamento-e-selecao" className="link-btn">
                                    Saber Mais <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-card">
                            <div className="service-card_img">
                                <img src="assets/img/servicos/1/2.png" alt="Banco de Talentos Vivo Rocvel" />
                            </div>
                            <div className="service-card_content">
                                <h4 className="service-card_title">
                                    <Link to="/hunting-especializado">Banco de Talentos Vivo</Link>
                                </h4>
                                <p className="service-card_text">
                                    Contamos com uma base de profissionais estratégica e constantemente atualizada. Isso nos permite antecipar demandas e encontrar perfis altamente qualificados com agilidade.
                                </p>
                                <Link to="/hunting-especializado" className="link-btn">
                                    Saber Mais <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-card">
                            <div className="service-card_img">
                                <img src="assets/img/servicos/1/3.png" alt="Recrutamento em Escala Rocvel" />
                            </div>
                            <div className="service-card_content">
                                <h4 className="service-card_title">
                                    <Link to="/estruturacao-de-equipes">Recrutamento em Escala</Link>
                                </h4>
                                <p className="service-card_text">
                                    Possuímos forte capacidade técnica e estrutura flexível para realizar contratações massivas sem perder o rigor e mantendo uma entrega extremamente ágil no mercado.
                                </p>
                                <Link to="/estruturacao-de-equipes" className="link-btn">
                                    Saber Mais <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-card">
                            <div className="service-card_img">
                                <img src="assets/img/servicos/1/4.png" alt="Foco em Retenção Rocvel" />
                            </div>
                            <div className="service-card_content">
                                <h4 className="service-card_title">
                                    <Link to="/consultoria-rh">Foco em Retenção</Link>
                                </h4>
                                <p className="service-card_text">
                                    Nossos processos garantem a máxima aderência cultural dos candidatos. Alinhamos competências técnicas e comportamentais para diminuir o turnover da sua operação.
                                </p>
                                <Link to="/consultoria-rh" className="link-btn">
                                    Saber Mais <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceView